import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { MessageService, SelectItem } from 'primeng/api';
import { CampaignController } from '@Workspace/_generated/services';
import { Router } from '@angular/router';
import { ICreativeAssetDto, ICreativeDto, IDescriptionJson, IDetailJson } from '@Workspace/_generated/interfaces';
import { IBaseCampaignDto } from '@Workspace/_generated/interfaces';
import { Functions, Constants, LookUps } from '@Workspace/common';
import { AuthService } from '@Workspace/auth';
import { CartItemService } from 'apps/core/src/app/modules/shared-core/components/card-item/card-item.service';
import { takeUntil } from 'rxjs/operators';
import { eAccountType, eCTAPinterest, eUserRole, eVideoType } from '@Workspace/_generated/enums';

@Component({
    selector: 'pinterest-ads',
    templateUrl: './pinterest-ads.component.html',
    styleUrls: ['./pinterest-ads.component.scss']
})
export class PinterestAdsComponent implements OnInit, OnDestroy {
    constructor(
        public campaignController: CampaignController,
        public messageService: MessageService,
        public router: Router,
        private authService: AuthService,
        private cardItemService: CartItemService,
    ) { }

    @Input() creative: ICreativeDto;
    @Input() reviewPage: boolean = false;
    @Input() campaign: IBaseCampaignDto;
    @Input() isApprove: boolean = false;

    @Output() openPreviewEvent: EventEmitter<any> = new EventEmitter();

    isUploadOk: boolean = true;
    ngUnsubscribe = new Subject();
    constants = Constants;
    functions = Functions;
    enumAccountType = eAccountType;
    enumUserRole = eUserRole;
    maxNumberOfFlights: number = 1;
    currentUser = this.authService.userSettings;
    isDestinationUrlOk: boolean = true;
    
    callToActionLabel: string;
    callToActionDD: SelectItem[] = [];
    cta: number;

    ngOnInit() {
        this.maxNumberOfFlights = Math.max(...this.campaign.creatives.map(x => x.creativeGroup));

        this.cardItemService.data
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(data => {
                this.isUploadOk = true;
                if (!!!data.creatives) return;
                this.creative.creativeAssets.forEach(ca => {
                    if (ca.isUploadValid != null || ca.isUploadValid != undefined)
                        this.isUploadOk = this.isUploadOk && ca.isUploadValid;
                });
            }
        );
        this.cta = Number(this.creative.detailJson?.callToAction);
        this.callToActionLabel = Functions.getEnumName(eCTAPinterest, Number(this.creative.detailJson?.callToAction));
        this.callToActionDD = LookUps.getCTAPinterestEnum();
        this.callToActionDD.find(x => x.value == eCTAPinterest.Show_Now_Buy_Now).label = 'Show Now/Buy Now';
        this.callToActionDD.unshift({ label: "-", value: 0 });

        this.creative.creativeAssets.forEach(x => {
            if (x.detailJson == null) {
                x.detailJson = {} as IDetailJson;
                x.detailJson.headline = '';
                x.detailJson.bodyText = [];
                x.detailJson.bodyText.push('');
                x.detailJson.linkDescription = '';
                x.detailJson.landingPageUrl = '';
                x.detailJson.facebookPageUrl = '';
                x.detailJson.videoType = eVideoType.Not_set;
                // x.detailJson.destinationUrl = '';
                x.detailJson.campaignTitle = '';
                x.detailJson.advertiser = '';
                x.detailJson.companyName = '';
                x.detailJson.shortTitle = '';
                x.detailJson.longTitle = '';
                x.detailJson.shortDescription = '';
                x.detailJson.longDescription = '';
                x.detailJson.callToAction = '';
                x.detailJson.headline2 = '';
                x.detailJson.description = '';
                x.detailJson.path1 = '';
                x.detailJson.path2 = '';
                x.detailJson.displayUrl = '';
                x.detailJson.adGroup = '';
                //x.inStreamVideoJson.videoType = eVideoType.Not_set;
                x.detailJson.postText = null;
                x.detailJson.privacyPolicy = null;
                x.detailJson.customDisclaimer = null;
                x.detailJson.copyOption1 = null;
                x.detailJson.copyOption2 = null;
                x.detailJson.buttonText = null;
                x.detailJson.destinationUrl = null;
                x.detailJson.storiesType = null;
                x.detailJson.introductoryText = '';
                x.detailJson.youTubeUrlToVideo = '';
                x.detailJson.clientYoutubeChannelUrl = '';
                x.detailJson.clientYoutubeEmail = '';
                x.detailJson.displayHandle = '';
            }
        });
    }

    removeAsset(asset: ICreativeAssetDto) {
        if(this.functions.checkCanChangeAsset(this.creative, this.campaign.startDate, this.campaign.campaignStatusId, this.campaign.statusId, this.campaign.campaignType, this.currentUser, !!this.campaign.campaignInventoryItems ? this.campaign.campaignInventoryItems[0] : null, this.maxNumberOfFlights))
        {
            let index = this.creative.creativeAssets.indexOf(asset);
            this.creative.creativeAssets.splice(index, 1);
        }
    }

    openPreview(event) {
        this.openPreviewEvent.emit(event);
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    setCreativeCallToAction(event) {
        this.callToActionLabel = Functions.getEnumName(eCTAPinterest, event.value);
        this.creative.detailJson.callToAction = this.cta.toString();
    }

    validationDestinationUrlMessage() {
        let textToMacth = this.creative.detailJson.destinationUrl;
        // var regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?%#[\]@!\$&'\(\)\*\+,;=.]+$/;
        var regex = /^[a-zA-Z0-9]+[^.\n]*[.][^.\n]+([.][^.\n]+)*$/;
        var found = textToMacth.match(regex);
        this.isDestinationUrlOk = true;
        if (found == null) {
            this.isDestinationUrlOk = false;
        }
    }

    addImage() {
        if (this.creative.creativeAssets.length < 5) {

            let newAsset = {} as ICreativeAssetDto;
            newAsset.id = crypto.randomUUID();
            newAsset.width = 0;
            newAsset.height = 0;
            newAsset.isValid = null;
            newAsset.creativeId = this.creative.id;
            newAsset.fileType = null;
            newAsset.fileSize = 0;
            newAsset.imageUrl = null;
            newAsset.fileName = null;
            newAsset.url = null;
            newAsset.isChanged = null;
            newAsset.isUploadValid = null;
            newAsset.isDeleted = null;

            if(newAsset.descriptionJson == null){
                newAsset.descriptionJson = {} as IDescriptionJson;
                newAsset.descriptionJson.cardNumber = 0;
                newAsset.descriptionJson.position = this.creative.creativeAssets.length;
            }

            if (newAsset.detailJson == null) {
                newAsset.detailJson = {} as IDetailJson;

                newAsset.detailJson.headline = '';
                newAsset.detailJson.bodyText = [];
                newAsset.detailJson.bodyText.push('');
                newAsset.detailJson.linkDescription = '';
                newAsset.detailJson.landingPageUrl = '';
                newAsset.detailJson.facebookPageUrl = '';
                newAsset.detailJson.videoType = 0;
                // newAsset.detailJson.destinationUrl = '';
                newAsset.detailJson.campaignTitle = '';
                newAsset.detailJson.advertiser = '';
                newAsset.detailJson.companyName = '';
                newAsset.detailJson.shortTitle = '';
                newAsset.detailJson.longTitle = '';
                newAsset.detailJson.shortDescription = '';
                newAsset.detailJson.longDescription = '';
                newAsset.detailJson.callToAction = '';
                newAsset.detailJson.headline2 = '';
                newAsset.detailJson.description = '';
                newAsset.detailJson.path1 = '';
                newAsset.detailJson.path2 = '';
                newAsset.detailJson.displayUrl = '';
                newAsset.detailJson.adGroup = '';
                newAsset.detailJson.postText = null;
                newAsset.detailJson.privacyPolicy = null;
                newAsset.detailJson.customDisclaimer = null;
                newAsset.detailJson.copyOption1 = null;
                newAsset.detailJson.copyOption2 = null;
                newAsset.detailJson.buttonText = null;
                newAsset.detailJson.destinationUrl = null;
                newAsset.detailJson.storiesType = null;
                newAsset.detailJson.introductoryText = '';
                newAsset.detailJson.youTubeUrlToVideo = '';
                newAsset.detailJson.clientYoutubeChannelUrl = '';
                newAsset.detailJson.clientYoutubeEmail = '';
                newAsset.detailJson.displayHandle = '';
            }
            this.creative.creativeAssets.push(newAsset);
            this.campaign.creatives.filter(x => x.id == this.creative.id)[0] = this.creative;

        }
    }
}
